/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
import { CloseCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { useMutation } from "@apollo/client";
import { Avatar, Button, Drawer, Dropdown, Form, Image, message, Tooltip } from "antd";
import React, { useRef, useState } from "react";
import { CREATE_EMAIL, UPDATE_EMAIL_STATUS } from "../../../../graphql/mutation";
import DownIcon from "../../../../icons/DownIcon";
import DeleteIcon from "../../../../icons/js/DeleteIcon";
import { ReplyIcon } from "../../../../icons/js/EmailIcons";
import { convertUtcToLocal } from "../../../../library/utils";
import { convertToInitials } from "../../../layoutComponent/layoutHelpers";
import { dateFromNow, ReplyEmail } from "../Emails";
import { parseEmailReply } from "../engagementHelpers";
import { CancelScheduleConfirmation } from "../leadConsent";
import { AccessPermissionAction } from "../../../../library/constants";
import { checkAccessPermission } from "../../../../library/helpers";
import { cleanHtmlForPreview } from "../../../../utils/htmlHelpers";
import { EMAIL_TYPE_ENUMS, renderEmailStatus } from "../../../../constant/EmailConstant";
import BouncedEmailResend from "./BouncedEmailResend";
import ReplayIcon from "../../../../icons/svg/replay-icon.svg";
import MoreIcon from "../../../../icons/svg/MoreOutlined.svg";
import { EmailTypeIcon } from "../../../email-view/emailHeader";
import "../messages.css";

/**
 *
 * @param {{thread:import("./emailMockData").EmailsData, index:number,setscheduleEmailCancelModal:import("react").Dispatch<import("react").SetStateAction<boolean>>,selectedEmail:import("./emailMockData").EmailsData,refetchEmails:()=>any,refetchEmailListFn:()=>any }} props
 * @returns
 */
export const ThreadsJSX = props => {
  const replyEmailRef = useRef(null);

  const [emailForm] = Form.useForm();
  const [isExpanded, setIsExpanded] = useState(false);
  const [deleteModal, setdeleteModal] = useState(false);
  const fromDetails =
    props.thread.message.direction === "FROM_LEAD"
      ? `${props.thread.from_} ${props.thread.from_}`
      : `${props?.thread?.message?.user?.fullName || ""} ${props.thread.from_}`;
  const toDetails =
    props.thread.message.direction === "TO_LEAD"
      ? `${props?.thread?.lead?.fullName} ${props.thread.to}`
      : `${props?.thread?.message?.user?.fullName || ""} ${props.thread.to}`;

  const [showReply, setshowReply] = useState({
    visible: false,
    email: "",
    id: "",
    showSubject: false,
    mode: "Reply",
    emailData: null,
  });

  // Enhanced email details state to include the mode
  const [emailDetails, setEmailDetails] = useState({
    threadId: "",
    from: "",
    to: "",
    emailBody: "",
    mode: "", // Add mode to track whether it was Reply or Forward
  });

  const { isReply, newMessage, originalMessage } = parseEmailReply(props.thread.bodyHtml);
  const [createEmail, { loading: emailLoader }] = useMutation(CREATE_EMAIL);
  const [updateEmailStatus, { loading: updateStatusLoader }] = useMutation(UPDATE_EMAIL_STATUS);
  const [mediaUploadLoader, setMediaUploadLoader] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isMessageExpanded, setIsMessageExpanded] = useState(false);
  // This user permission is check for the user to delete/tra email
  const canDeleteEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_DELETE);
  // This user permission is check for the user to send/reply/forward email
  const canSendEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_SEND);

  const handleDelete = async () => {
    const res = await updateEmailStatus({
      variables: {
        action: "DELETE",
        sesMessageIds: [props.thread.sesMessageId],
      },
    });
    if (res.data.updateEmailStatus.statusCode === 200) {
      message.success(res.data.updateEmailStatus.message);
      props.refetchEmails();
      props.refetchEmailListFn();
      setdeleteModal(false);
    } else {
      message.error(res.data.updateEmailStatus.message);
    }
  };

  const emailActionOptions = [];

  if (canDeleteEmail) {
    emailActionOptions.push({
      label: "Delete",
      key: "DELETE",
      icon: <DeleteIcon size="20" color="#64748B" />,
      onClick: e => {
        e.domEvent.stopPropagation();
        setdeleteModal(true);
      },
    });
  }

  const emailScheduledOptions = [];

  if (canDeleteEmail) {
    emailScheduledOptions.push(
      {
        label: "Cancel Schedule",
        icon: <CloseCircleOutlined />,
        key: "CANCEL_SCHEDULE",
        onClick: e => {
          e.domEvent.stopPropagation();
          props.setscheduleEmailCancelModal(true);
        },
      },
      {
        label: "Delete",
        icon: <DeleteIcon size="20" />,
        key: "DELETE",
        danger: true,
        onClick: e => {
          e.domEvent.stopPropagation();
          setdeleteModal(true);
        },
      }
    );
  }

  const resetEmailDetails = () => {
    setEmailDetails({
      threadId: "",
      from: "",
      to: "",
      emailBody: "",
      mode: "",
    });
  };

  return (
    <div
      className={`p-5 flex-col-centered ${
        isMessageExpanded
          ? "gap-7 !bg-white"
          : props?.index % 2 === 0
          ? "bg-grey-50 border-grey-200"
          : ""
      }`}
    >
      <div
        onClick={() => setIsMessageExpanded(!isMessageExpanded)}
        className="flex-row-centered cursor-pointer w-full gap-2"
      >
        <div>
          <Avatar className="h-7 w-7 ">{convertToInitials(props.thread.from_)}</Avatar>
        </div>
        <div className="flex-col-centered w-full">
          {/* From Details */}
          <div className="flex-row-centered w-full justify-between">
            <div className="flex gap-1">
              <span className="sm-400 text-grey-500">{fromDetails}</span>
              {renderEmailStatus(props.thread.status)}
              {props?.thread?.type !== EMAIL_TYPE_ENUMS.MANUAL && (
                <EmailTypeIcon className="-ml-1" type={props.thread.type} />
              )}
            </div>
            <div className="flex-row-centered items-center gap-2">
              <Tooltip title={convertUtcToLocal(props.thread.createTs, "LLLL")}>
                <span className="xs-400 text-[#00000073]">
                  {dateFromNow(props.thread.createTs)}
                </span>
              </Tooltip>

              <div className="border border-solid flex-row-centered shadow-[0px_2px_0px_0px_#00000005] bg-white border-[#D9D9D9] rounded-md">
                <Tooltip title="Reply">
                  <div
                    onClick={e => {
                      e.stopPropagation();
                      // @ts-ignore
                      setshowReply(prev => ({
                        visible: !prev.visible,
                        email: props.thread.to,
                        id: props.thread.id,
                        showSubject: true,
                        mode: "Reply",
                        emailData: props.thread,
                      }));
                    }}
                    className="p-2 w-8 cursor-pointer flex-row-centered items-center justify-center"
                  >
                    <Image preview={false} src={ReplayIcon} />
                  </div>
                </Tooltip>

                {canSendEmail && <div className="w-0.2 h-8 border border-solid border-[#D9D9D9]" />}
                {canSendEmail && (
                  <Tooltip title="Forward">
                    <div
                      onClick={e => {
                        e.stopPropagation();
                        setshowReply(prev => ({
                          visible: !prev.visible,
                          email: "",
                          id: props.thread.id,
                          showSubject: true,
                          mode: "Forward",
                          emailData: props.thread,
                        }));
                      }}
                      className="p-2 w-8 -mb-1 cursor-pointer flex-row-centered items-center justify-center"
                    >
                      <ReplyIcon color="#1d2129" className="rotate-180 scale-y-[-1]" />
                    </div>
                  </Tooltip>
                )}

                <div className="w-0.2 h-8 border border-solid border-[#D9D9D9]" />
                {/* @ts-ignore */}
                {props?.thread?.scheduled ? (
                  <Dropdown
                    trigger={["click"]}
                    menu={{
                      items: emailScheduledOptions,
                    }}
                  >
                    <div
                      onClick={e => e.stopPropagation()}
                      className="p-2 w-8 flex-row-centered cursor-pointer items-center justify-center"
                    >
                      <DownIcon />
                    </div>
                  </Dropdown>
                ) : (
                  <Dropdown
                    menu={{
                      items: emailActionOptions,
                    }}
                    trigger={["click"]}
                  >
                    <div
                      onClick={e => e.stopPropagation()}
                      className="p-2 w-8 flex-row-centered cursor-pointer items-center justify-center"
                    >
                      <Image src={MoreIcon} preview={false} />
                    </div>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>
          {/* To Details */}
          {isMessageExpanded && (
            <div className="flex-row-centered w-full justify-between">
              <span className="sm-400 text-grey-700">To: {toDetails}</span>
            </div>
          )}
        </div>
      </div>
      <div
        className={`px-[37px] sm-400 text-grey-900 w-full ${
          isMessageExpanded
            ? "thread-email-body"
            : "whitespace-nowrap overflow-hidden text-ellipsis"
        }`}
        // @ts-ignore
        dangerouslySetInnerHTML={{
          __html: isMessageExpanded ? newMessage : cleanHtmlForPreview(newMessage, 200),
        }}
      />
      {props?.thread?.message.mmsObjects?.length > 0 &&
        props?.thread?.message.mmsObjects?.map((item, index) => (
          <span
            className="cursor-pointer max-w-max px-3 border border-solid border-grey-200 rounded-[1111px] text-brand-500"
            onClick={() => window.open(item.mediaUrl)}
            key={index}
          >
            {item.mediaUrl.split("/").pop()}
          </span>
        ))}
      <BouncedEmailResend
        className="w-full px-[37px]"
        direction={props.thread?.message?.direction}
        status={props.thread?.status}
        to={props.thread?.to}
        subject={props.thread?.subject}
        content={props.thread?.bodyHtml || props.thread?.message?.content}
        leadId={props.thread?.lead?.id || props.thread?.message?.leadId}
        leadOpportunityId={props.thread?.message?.leadOpportunityId}
        onResent={() => props.refetchEmailListFn?.()}
      />
      {isReply && isMessageExpanded && (
        <div className="reply-section">
          <span className="toggle-reply cursor-pointer" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? "..." : "..."}
          </span>

          {isExpanded && (
            <blockquote
              className="border-0 border-l border-solid border-[#ccc] text-[#666] pl-2"
              // @ts-ignore
              dangerouslySetInnerHTML={{ __html: originalMessage }}
            />
          )}
        </div>
      )}
      {showReply?.visible && (
        <Drawer
          open={showReply.visible}
          onClose={() => {
            // Save the current email details before closing the drawer
            const emailContent = replyEmailRef?.current?.getContent() || "";
            setEmailDetails({
              threadId: props.thread.id,
              from: props.thread.from_,
              to: showReply.email,
              emailBody: emailContent,
              mode: showReply.mode, // Save the mode (Reply or Forward)
              subject: replyEmailRef?.current?.getSubject() || "",
            });

            setshowReply({ visible: false, email: "" });
          }}
          width="40%"
          destroyOnClose
          title={
            showReply?.mode === "Forward"
              ? "Forward Email"
              : `Reply to ${showReply?.email || showReply?.emailData?.from_}`
          }
          footer={
            <div className="flex-row-centered w-full items-center">
              <div className="flex-row-centered gap-1">
                <Button
                  loading={isSending || emailLoader || mediaUploadLoader}
                  onClick={() => emailForm.submit()}
                  type="primary"
                >
                  Send
                </Button>
                <Button
                  onClick={() => {
                    // Reset the state when Cancel is clicked
                    resetEmailDetails();
                    setshowReply({ visible: false, email: "" });
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          }
          afterOpenChange={open => {
            // Only restore content if it's the same thread ID AND the same mode
            if (
              open &&
              props.thread.id === emailDetails.threadId &&
              showReply.mode === emailDetails.mode
            ) {
              setTimeout(() => {
                if (replyEmailRef?.current?.setContent) {
                  replyEmailRef.current.setContent(emailDetails.emailBody);
                }
                if (replyEmailRef?.current?.setSubject && emailDetails.subject) {
                  replyEmailRef.current.setSubject(emailDetails.subject);
                }
              }, 500);
            }
          }}
        >
          <ReplyEmail
            key={props.thread.id}
            // @ts-ignore
            showReply={showReply}
            // @ts-ignore
            setshowReply={setshowReply}
            selectedLead={null}
            emailForm={emailForm}
            createEmail={createEmail}
            selectedEmail={props.selectedEmail}
            refetchEmails={props.refetchEmails}
            refetchEmailListFn={props.refetchEmailListFn}
            mediaUploadLoader={mediaUploadLoader}
            setMediaUploadLoader={setMediaUploadLoader}
            onSubmitStateChange={setIsSending}
            ref={replyEmailRef}
            resetEmailDetails={resetEmailDetails}
          />
        </Drawer>
      )}
      <CancelScheduleConfirmation
        open={deleteModal}
        setOpen={setdeleteModal}
        cancelText="No"
        okText="Yes, Delete"
        description="Are you sure you want to delete this email?"
        title="Delete email"
        onOk={handleDelete}
        loading={updateStatusLoader}
      />
    </div>
  );
};
